import { formatPrismicData } from '@monofront/business/utils';
import { ICarouselProductBundles } from './types';
import { CarouselFreshProductsProps } from '../CarouselFreshProducts/types';

export const mapCarouselProductBundles = ({
  prismicContent,
  position,
}: {
  prismicContent: CarouselFreshProductsProps;
  position: number;
}): ICarouselProductBundles => {
  const { primary, items }: ICarouselProductBundles = formatPrismicData(
    prismicContent,
    ['product_bundle'],
  );

  return {
    primary,
    items,
    position,
  };
};
